import React, { useState, useEffect, useCallback } from "react";
import { auth } from "../../firebase";
import { signOut } from "firebase/auth";
import { getDocs, query, collection, where, limit } from "firebase/firestore";
import { db } from "../../firebase";
import { Container } from "../../style/global/styledComponents/Containers";
import {
  NameBarUp,
  Name,
  Avatar,
  NameBarDown,
  NameBar,
  Description,
  Main,
  ObjectBar,
  Text,
  Button,
  ButtonBar,
  DivFlex,
  DivFlex1,
} from "../student/studentPanel";
import DrawerMyChildren from "./DrawerMyChildren";

function ParentPanel() {
  const [user, setUser] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);

  // ✅ Aktif panel localStorage’dan yükleniyor
  const [activeDiv, setActiveDiv] = useState(() => {
    const stored = localStorage.getItem("parentActiveDiv");
    return stored ? parseInt(stored, 10) : 1;
  });

  const handleButtonClick = (divNumber) => {
    setActiveDiv(divNumber);
    localStorage.setItem("parentActiveDiv", divNumber);
  };

  const handleSignOut = useCallback(() => {
    localStorage.removeItem("parentUser");
    localStorage.removeItem("parentActiveDiv");
    signOut(auth);
  }, []);

  // ✅ Kullanıcı verisi cache + Firestore
  useEffect(() => {
    const cachedUser = localStorage.getItem("parentUser");
    if (cachedUser) {
      const parsedUser = JSON.parse(cachedUser);
      setUser(parsedUser);
      if (parsedUser?.userData?.avatar) {
        setAvatarUrl(
          `${process.env.PUBLIC_URL}/avatars/avatar${parsedUser.userData.avatar}.png`
        );
      }
      return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) return;

    const q = query(
      collection(db, "users"),
      where("uid", "==", currentUser.uid),
      limit(1)
    );

    const getUserData = async () => {
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        const userData = doc.data();
        setUser(userData);
        localStorage.setItem("parentUser", JSON.stringify(userData));

        if (userData?.userData?.avatar) {
          setAvatarUrl(
            `${process.env.PUBLIC_URL}/avatars/avatar${userData.userData.avatar}.png`
          );
        }
      });
    };

    getUserData();
  }, []);

  return (
    <Container>
      <NameBarUp>
        <NameBar>
          <Avatar>
            {avatarUrl && (
              <img
                src={avatarUrl}
                alt="Avatar"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </Avatar>
          <NameBarDown>
            <Name>{user && <p>{user.userData.displayName}</p>}</Name>
            <Description>
              <p>Burada kendi çocuklarınızı takip edebilirsiniz.</p>
            </Description>
          </NameBarDown>
        </NameBar>
      </NameBarUp>

      <Main>
        <ButtonBar>
          <DivFlex1 style={{ marginBottom: "1.5rem" }}>
            <Text>Sayın Veli</Text>
          </DivFlex1>
          <DivFlex onClick={() => handleButtonClick(1)}>
            <Button>Çocuklarım</Button>
          </DivFlex>
          {/* <DivFlex onClick={() => handleButtonClick(2)}>
            <Button>İlerleme Raporları</Button>
          </DivFlex>
          <DivFlex onClick={() => handleButtonClick(3)}>
            <Button>Destek Talepleri</Button>
          </DivFlex> */}
          <DivFlex onClick={handleSignOut}>
            <Button>Çıkış</Button>
          </DivFlex>
        </ButtonBar>

        <ObjectBar>
          <div style={{ display: activeDiv === 1 ? "block" : "none" }}>
            <DrawerMyChildren />
          </div>
          {/* <div style={{ display: activeDiv === 2 ? "block" : "none" }}>
            <div>Raporlar (yakında)</div>
          </div>
          <div style={{ display: activeDiv === 3 ? "block" : "none" }}>
            <div>Destek Alanı (yakında)</div>
          </div> */}
        </ObjectBar>
      </Main>
    </Container>
  );
}

export default ParentPanel;
